import FlashMessage from '../index';
import bus from '../../../plugins/bus';

import baseTemplate from './index.html';
import header from '../partials/header.html';
import footer from '../partials/footer.html';

export default FlashMessage.extend({
  name: 'SihhFlashMessage',
  template: header + baseTemplate + footer,
  methods: {
    openCalenderModal: () => {
      bus.$emit('openModal', 'CalenderModal');
    },
  },
});



// WEBPACK FOOTER //
// ./src/js/components/flash-messages/sihh/index.js